import script from "./ApprovalCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalCenter.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalCenter.vue?vue&type=style&index=0&id=292ab7ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-292ab7ee"]])

export default __exports__